// extracted by mini-css-extract-plugin
export var brand = "_2f-9";
export var compact = "_2f-6";
export var extraSmall = "_2f-7";
export var icon = "_2f-0";
export var large = "_2f-4";
export var light = "_2f-1";
export var medium = "_2f-5";
export var outline = "_2f-b";
export var primaryDark = "_2f-a";
export var primaryLight = "_2f-8";
export var primaryModern = "_2f-c";
export var success = "_2f-2";
export var successSolid = "_2f-3";